
import React, { useState, useEffect, useMemo } from "react";
import ReactPaginate from "react-paginate";
import './Pegination.css'

export const Pegination = ({ PerPageCount, TotalCount, setTo, setFrom, setrowNo, setCurrentPage, CurrentPage, IsClear }) => {



    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        let paglink = document.querySelectorAll('.page-item');
        paglink[1].firstChild.click();
    }, [IsClear])


    useMemo(() => {
        const endOffset = CurrentPage + PerPageCount;
        setPageCount(Math.ceil(TotalCount / PerPageCount));
        setTo(endOffset)
        setFrom(CurrentPage + 1)
    }, [CurrentPage, TotalCount]);

    const handlePageClick = (event) => {
        var newOffset = event.selected * PerPageCount % TotalCount;
        setCurrentPage(newOffset)
    };

    return (
        <div className="mt-3 d-flex justify-content-end pb-2">
            <ReactPaginate
             
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                marginPagesDisplayed={4}
                pageCount={pageCount}
                previousLabel="< previous"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={itemOffset}
            />
        </div>
    )
}